module.exports = __webpack_public_path__ + "static/media/coffee_free_fr.326d864b.jpg";